import { makeObservable, observable, runInAction } from "mobx";

import { shallowCopy } from "@noli/core";
import { ABCStore } from "@noli/business";

export type LeftPanelType =
  | "txt2img"
  | "params2img" //参数生成
  | "txt2imgVariation" //相似
  | "img2img" //图片转换
  | "negativePrompt" // 去除
  | "imageProcess" // 高分辨率
  | "outpainting" // 图片外延
  | "inpainting" // 图片擦除
  | "text2img-inpainting" // 图片替换
  | "txt2imgPresets" // 玩图
  | "settings"
  | "matt"; // 抠图;
export interface IUIStore {
  leftPanel: LeftPanelType;
  rightPanelTab: number;
  wenxinExpand: boolean;
  txt2imgExpand: boolean;
  txt2imgVariationExpand: boolean;
  img2imgExpand: boolean;
  txt2imgInpaintingExpand: boolean;
  negativePromptExpand: boolean;
  importExpand: boolean;
  imageProcessExpand: boolean;
  inpaintingExpand: boolean;
  outpaintingExpand: boolean;
  txt2imgCatExpand: boolean;
}
class UIStore extends ABCStore<IUIStore> implements IUIStore {
  leftPanel: LeftPanelType = "txt2img";
  rightPanelTab = 0;
  wenxinExpand = false;
  txt2imgExpand = true;
  txt2imgVariationExpand = false;
  img2imgExpand = false;
  txt2imgInpaintingExpand = false;
  negativePromptExpand = false;
  importExpand = false;
  imageProcessExpand = false;
  inpaintingExpand = false;
  outpaintingExpand = false;
  txt2imgCatExpand = true;

  constructor() {
    super();
    makeObservable(this, {
      leftPanel: observable,
      rightPanelTab: observable,
      wenxinExpand: observable,
      txt2imgExpand: observable,
      txt2imgVariationExpand: observable,
      img2imgExpand: observable,
      txt2imgInpaintingExpand: observable,
      negativePromptExpand: observable,
      importExpand: observable,
      imageProcessExpand: observable,
      inpaintingExpand: observable,
      outpaintingExpand: observable,
      txt2imgCatExpand: observable,
    });
  }

  get info(): IUIStore {
    return this;
  }
}

type UIKey = keyof IUIStore;
type UIKeys = UIKey[];
export const uiStore = new UIStore();
export const updateUI = uiStore.updateProperty.bind(uiStore);
export const setRightPanelTab = (tabIndex: number) => {
  uiStore.updateProperty("rightPanelTab", tabIndex);
};

export const setExpandFn = (property: UIKey, conflicts: UIKeys) => (expand: boolean) => {
  runInAction(() => {
    uiStore.updateProperty(property, expand);
    if (expand) {
      conflicts.forEach((p) => uiStore.updateProperty(p, false));
    }
  });
};
const txt2imgPanels: UIKeys = [
  "wenxinExpand",
  "txt2imgExpand",
  "txt2imgVariationExpand",
  "img2imgExpand",
  "negativePromptExpand",
  "outpaintingExpand",
  "importExpand",
];
export const setTxt2ImgExpandFn = (property: UIKey) => (expand: boolean) => {
  const all = shallowCopy(txt2imgPanels);
  all.splice(all.indexOf(property), 1);
  return setExpandFn(property, all)(expand);
};
export const setWenxinExpand = setTxt2ImgExpandFn("wenxinExpand");
export const setTxt2ImgExpand = setTxt2ImgExpandFn("txt2imgExpand");
export const setTxt2ImgVariationExpand = setTxt2ImgExpandFn("txt2imgVariationExpand");
export const setImg2ImgExpand = setTxt2ImgExpandFn("img2imgExpand");
export const setNegativePromptExpand = setTxt2ImgExpandFn("negativePromptExpand");
export const setOutpaintingExpand = setTxt2ImgExpandFn("outpaintingExpand");
export const setImportExpand = setTxt2ImgExpandFn("importExpand");

const img2imgPanels: UIKeys = ["inpaintingExpand", "imageProcessExpand", "txt2imgInpaintingExpand"];
export const setImg2ImgExpandFn = (property: UIKey) => (expand: boolean) => {
  const all = shallowCopy(img2imgPanels);
  all.splice(all.indexOf(property), 1);
  return setExpandFn(property, all)(expand);
};
export const setImageProcessExpand = setImg2ImgExpandFn("imageProcessExpand");
export const setInpaintingExpand = setImg2ImgExpandFn("inpaintingExpand");
export const setTxt2ImgInpaintingExpand = setImg2ImgExpandFn("txt2imgInpaintingExpand");

export const setTxt2ImgCatExpand = setExpandFn("txt2imgCatExpand", []);
